export class SOVarientIdReq{
    saleOrderId : number
    varientId?: number
    plantId?:number
    packStyleId?:[]
    

    constructor(saleOrderId : number,varientId?:number,plantId?:number,packStyleId?:[]){
        this.saleOrderId = saleOrderId
        this.varientId = varientId
        this.plantId = plantId
        this.packStyleId = packStyleId
    }

}